<template>
    <div class="third_diagram">
        <div class="third_diagram_box">
            <div class="third_diagram_box_main" id="main" ref="main">
                <div
                    id="canvas"
                    ref="canvas"
                    class="canvas-wrap"
                    :style="
                        `transform: scale(${scale});width:${width};height:${height};top:${top}px;left:${left}px`
                    "
                >
                    <img
                        class="bg-img"
                        src="../../../assets/image/diagram/diagram_third1.svg"
                        alt
                        srcset
                    />
                    <div
                        v-for="(item, index) in datas"
                        :key="item.point_id"
                        class="data-wrap"
                        :style="`top:${item.top}%;left:${item.left}%;`"
                    >
                        <div class="data-box">
                            <div
                                class="data-box-name"
                                v-if="index == 0 || index == 11"
                            >
                                Ia(A)
                            </div>
                            <div class="data-box-data">
                                <div class="box-data-data">{{ item.ia }}</div>
                                <!-- <div class="box-data-unit">A</div> -->
                            </div>
                        </div>
                        <div class="data-box">
                            <div
                                class="data-box-name"
                                v-if="index == 0 || index == 11"
                            >
                                Ib(A)
                            </div>
                            <div class="data-box-data">
                                <div class="box-data-data">{{ item.ib }}</div>
                                <!-- <div class="box-data-unit">A</div> -->
                            </div>
                        </div>
                        <div class="data-box">
                            <div
                                class="data-box-name"
                                v-if="index == 0 || index == 11"
                            >
                                Ic(A)
                            </div>
                            <div class="data-box-data">
                                <div class="box-data-data">{{ item.ic }}</div>
                                <!-- <div class="box-data-unit">A</div> -->
                            </div>
                        </div>
                    </div>
                    <div class="data-wrap" style="top: 7%;left: 80%">
                        <div class="data-box">
                            <div class="data-box-name">
                                Ua
                            </div>
                            <div class="data-box-data">
                                <div class="box-data-data">{{ ua }}</div>
                            </div>
                        </div>
                        <div class="data-box">
                            <div class="data-box-name">
                                Ub
                            </div>
                            <div class="data-box-data">
                                <div class="box-data-data">{{ ub }}</div>
                            </div>
                        </div>
                        <div class="data-box">
                            <div class="data-box-name">
                                Uc
                            </div>
                            <div class="data-box-data">
                                <div class="box-data-data">{{ uc }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as api from "@/http/http-60.js";
export default {
    data() {
        return {
            left: "0",
            top: "-260",
            scale: 0.55,
            timer: null,
            datas: [
                {
                    point_id: "1572426145151807488",
                    name: "4011总电表3",
                    top: 52.5,
                    left: 0,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572426357593305088",
                    name: "4021电源由#2专变电房P17柜引来",
                    top: 52.5,
                    left: 13,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572426409548148736",
                    name: "4033码头集水池潜污泵控制箱2",
                    top: 52.5,
                    left: 21,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572426471082782720",
                    name: "4034路灯4@",
                    top: 52.5,
                    left: 29,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572426705208832000",
                    name: "4035路灯5@",
                    top: 52.5,
                    left: 37,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572426758858174464",
                    name: "4036船舶岸电箱3#，5#",
                    top: 52.5,
                    left: 46,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572426838944215040",
                    name: "4037备用回路",
                    top: 52.5,
                    left: 54,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572427018615615488",
                    name: "4038船舶岸电箱4#，6#",
                    top: 52.5,
                    left: 63,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572427172324274176",
                    name: "4039船舶岸电箱1#，2#",
                    top: 52.5,
                    left: 72,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572427249042288640",
                    name: "40310码头东北面",
                    top: 52.5,
                    left: 80,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572427297465528320",
                    name: "4043码头集水池潜污泵控制箱2",
                    top: 52.5,
                    left: 88,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1574327660821065728",
                    name: "4061G无功补偿",
                    top: 98,
                    left: 0,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1574302537913184256",
                    name: "4072前方办公楼、 机修车间照明、油污",
                    top: 98,
                    left: 11,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572427913394876416",
                    name: "4051G门机接电箱AP7",
                    top: 98,
                    left: 21,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572427850136383488",
                    name: "40410码头集水池潜污泵控制箱3",
                    top: 98,
                    left: 31,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572427735824822272",
                    name: "4049码头西北面",
                    top: 98,
                    left: 41,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572427670209130496",
                    name: "4048码头岸电箱AD6",
                    top: 98,
                    left: 50,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572427571705901056",
                    name: "4047备用回路",
                    top: 98,
                    left: 59,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572427472481251328",
                    name: "4046码头岸电箱AD5",
                    top: 98,
                    left: 69,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572427412561424384",
                    name: "4045码头岸电箱AD4",
                    top: 98,
                    left: 79,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572427352083755008",
                    name: "4044电动小车充电桩",
                    top: 98,
                    left: 88,
                    ia: "",
                    ib: "",
                    ic: ""
                }
            ],
            ua: "",
            ub: "",
            uc: ""
        };
    },
    mounted() {
        this.zoom();
        this.drag();
        this.getData();
        this.setTimer();
        this.setImgSize();
        window.onresize = () => {
            this.setImgSize();
        };
    },
    methods: {
        setTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                this.getData();
            }, 1000 * 60);
        },
        getData() {
            let pointIds = [];
            this.datas.forEach(item => {
                pointIds.push(item.point_id);
            });
            api.getDataAll(pointIds).then(res => {
                let valueJson = res.bus_json;
                this.datas.forEach(item => {
                    let point = valueJson[item.point_id];
                    if (item.point_id == "1572426145151807488") {
                        this.ua = point && point.v_a;
                        this.ub = point && point.v_b;
                        this.uc = point && point.v_c;
                    }
                    item.ia = point && point.a_a;
                    item.ib = point && point.a_b;
                    item.ic = point && point.a_c;
                });
            });
        },
        setImgSize() {
            if (window.innerWidth >= 2560) {
                this.basisUnitH = 1.2;
                this.basisUnitV = 1.2;
            } else if (window.innerWidth < 2560 && window.innerWidth >= 1900) {
                this.basisUnitH = 1.0;
                this.basisUnitV = 0.82;
            } else if (window.innerWidth < 1920 && window.innerWidth >= 1660) {
                this.basisUnitH = 0.82;
                this.basisUnitV = 0.82;
            } else if (window.innerWidth < 1660 && window.innerWidth >= 1420) {
                this.basisUnitH = 0.7;
                this.basisUnitV = 0.7;
            } else if (window.innerWidth < 1420 && window.innerWidth >= 1320) {
                this.basisUnitH = 0.6;
                this.basisUnitV = 0.6;
            } else {
            }
        },
        zoom() {
            let vm = this;
            if (navigator.userAgent.indexOf("Firefox") != -1) {
                //FF
                document.getElementById("main").addEventListener(
                    "DOMMouseScroll",
                    function(event) {
                        event = event || window.event;
                        if (event.detail > 0) {
                            vm.scale =
                                vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                        } else {
                            vm.scale += 0.1;
                        }
                        event.cancelBubble = true;
                        event.stopPropagation();
                        event.preventDefault();
                    },
                    false
                );
            } else {
                //非FF
                document.getElementById("main").onmousewheel = function(event) {
                    event = event || window.event;
                    if (event.deltaY > 0) {
                        vm.scale = vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                    } else {
                        vm.scale += 0.1;
                    }
                    event.cancelBubble = true;
                    event.stopPropagation();
                    event.preventDefault();
                };
            }
        },
        drag() {
            let oDiv = this.$refs.canvas;
            let vm = this;
            oDiv.onmousedown = function(en) {
                let ev = ev || event;
                let disX = en.clientX - oDiv.offsetLeft;
                let disY = en.clientY - oDiv.offsetTop;
                oDiv.onmousemove = function(en) {
                    let ev = ev || event;
                    if (
                        en.clientY > 0 &&
                        en.clientY < vm.$refs.main.clientHeight &&
                        en.clientX > 0 &&
                        en.clientX < vm.$refs.main.clientWidth
                    ) {
                        vm.top = en.clientY - disY;
                        vm.left = en.clientX - disX;
                    }
                };
                oDiv.onmouseup = function() {
                    oDiv.onmousemove = null;
                };
                return false;
            };
        }
    },
    destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss">
.third_diagram {
    width: 100%;
    height: 100%;
    color: #fff;
    padding: 0 2rem 0rem 2rem;
    padding-top: 0;
    box-sizing: border-box;
    position: relative;
    .third_diagram_box {
        margin: 0 auto;
        text-align: center;
        align-self: center;
        width: 100%;
        height: 100%;
        position: relative;
        .third_diagram_box_main {
            top: 0%;
            left: 0%;
            width: 100%;
            padding: 2rem 2rem 0 2rem;
            box-sizing: border-box;
            height: 100%;
            position: relative;
            overflow: hidden;
            cursor: move;
            .canvas-wrap {
                width: 100%;
                // min-height: 100%;
                // height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                box-sizing: border-box;

                .bg-img {
                    width: 100%;
                    height: 100%;
                }

                .data-wrap {
                    position: absolute;
                    color: #fff;
                    font-size: 1rem;
                    .data-box {
                        display: flex;
                        height: 1.6rem;
                        line-height: 1.6rem;
                        margin-bottom: 0.2rem;
                        .data-box-name {
                            color: #dbf743;
                            width: 3rem;
                        }
                        .data-box-data {
                            width: 6rem;
                            text-align: right;
                            background: #111f45;
                            border-radius: 1rem;
                            display: inline-flex;
                            .box-data-data {
                                flex: 1;
                                text-align: center;
                            }
                            .box-data-unit {
                                width: auto;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
